import React, { useCallback, useContext } from "react";
import { FaEllipsisV } from "react-icons/fa";
import SettingChatItem from "./ChatSettingItem";
import SocketContext from "../../../providers/Socket";
const ChatSettings = ({ chat, onLoadChats, clearCurrentChatHandler }) => {
    const { socket } = useContext(SocketContext);
    const blockUserHandler = useCallback(() => {
        return new Promise((resolve, reject) => {
            if (!socket || !chat || !chat.details)
                return;
            return socket === null || socket === void 0 ? void 0 : socket.emit("block-user", chat.details.pid, chat.details.oid, chat.details.rooms[0].uid, function () {
                onLoadChats();
                clearCurrentChatHandler();
                resolve(true);
            });
        });
    }, [socket, chat]);
    const deleteChatHandler = useCallback(() => {
        return new Promise((resolve, reject) => {
            var _a, _b, _c, _d, _e, _f;
            if (!socket || !chat || !chat.details)
                return;
            const data = { "pid": (_a = chat.details) === null || _a === void 0 ? void 0 : _a.pid, "oid": (_b = chat.details) === null || _b === void 0 ? void 0 : _b.oid, "uid": (_c = chat.details) === null || _c === void 0 ? void 0 : _c.rooms[0].uid };
            return socket === null || socket === void 0 ? void 0 : socket.emit("delete-room", (_d = chat.details) === null || _d === void 0 ? void 0 : _d.pid, (_e = chat.details) === null || _e === void 0 ? void 0 : _e.oid, Number((_f = chat.details) === null || _f === void 0 ? void 0 : _f.rooms[0].uid), function (_) {
                console.log(_);
                onLoadChats();
                clearCurrentChatHandler();
                resolve(true);
            });
        });
    }, [socket, chat]);
    return (React.createElement("div", { className: "dropdown" },
        React.createElement("button", { type: 'button', className: 'btn btn-sm btn-icon btn-color-primary btn-active-light-primary  d-flex justify-content-center align-items-center', id: "SettingsMenu", "data-bs-toggle": "dropdown", "aria-expanded": "false" },
            React.createElement(FaEllipsisV, { style: { fontSize: "16px", color: "#000" } })),
        React.createElement("div", { className: 'dropdown-menu p-0', "aria-labelledby": "SettingsMenu" },
            React.createElement("ul", { className: "list__dropdown-ul", style: { listStyleType: "none" } },
                React.createElement(SettingChatItem, { listKey: 'block_user', onActionHandler: blockUserHandler }),
                React.createElement(SettingChatItem, { listKey: 'delete-room', onActionHandler: deleteChatHandler })))));
};
export default ChatSettings;
